import { useTranslation } from 'react-i18next';
import { Icon } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';
import { CarouselModal } from '@anytag/shared-molecules';
import { EngagementDetail, ProposalInfluencer } from '@anytag/graphql';
import { useControlPostDetailsModal } from '@anytag/shared-hooks';
import { useEngagementProposalInfluencerDetailsParam } from '../hooks';
import { ProposalDerivedProps } from '../../shared/types';
import { InfluencerOverview } from './InfluencerOverview';
import { InfluencersCarousel } from './InfluencersCarousel';
import { ProposalInfluencerAccountProfile } from './ProposalInfluencerAccountProfile';

interface ProposalInfluencersDetailsModalProps {
  engagement: EngagementDetail;
  allInfluencers: ProposalDerivedProps['allInfluencers'];
}
export const ProposalInfluencersDetailsModal = ({
  allInfluencers,
  engagement
}: ProposalInfluencersDetailsModalProps) => {
  const { t } = useTranslation();
  const { paramKey, influencerPopupId } = useEngagementProposalInfluencerDetailsParam();
  const { selectedPost, siblingPostId, closePost, handleClickNext, handleClickPrev } =
    useControlPostDetailsModal<ProposalInfluencer>({ posts: allInfluencers, paramKey });

  const selectedInfluencer = allInfluencers.find((influencer) => influencer.id === influencerPopupId);

  return (
    <CarouselModal
      size="content"
      onClose={closePost}
      open={!!selectedPost}
      withCloseIcon={false}
      onClickNext={handleClickNext}
      onClickPrev={handleClickPrev}
      siblingPostId={siblingPostId}
      classNames={{
        wrapper: cn('min-h-0'),
        backdrop: cn('bg-black-90'),
        panel: cn('overflow-hidden bg-transparent pt-0 shadow-none')
      }}
    >
      <div className="mx-auto flex h-[95vh] w-[85vw] flex-col overflow-hidden">
        <div className="mb-6 flex items-end justify-between">
          <h2 className="text-xl leading-6 text-white">{t('General.Selected Influencer')}</h2>

          <button onClick={closePost} className="text-uppercase flex cursor-pointer items-center hover:opacity-60">
            <span className="text-base text-black-40">{t('Button.Close')}</span>
            <Icon icon="close" variant="light-gray" size={12} className="ml-2" />
          </button>
        </div>

        <InfluencersCarousel influencers={allInfluencers} />

        {selectedInfluencer ? (
          <div className="mt-4 overflow-y-auto bg-black-10 pb-6">
            <InfluencerOverview data={selectedInfluencer} engagement={engagement} />
            <ProposalInfluencerAccountProfile influencerId={selectedInfluencer.id} engagementId={engagement.id} />
          </div>
        ) : null}
      </div>
    </CarouselModal>
  );
};
